export class VerifyEmailRequest {
  token: string;
}
